import { Component, OnInit, Input, ViewChild, TemplateRef, EventEmitter, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Subject } from 'rxjs/Subject';
// Observable class extensions
import 'rxjs/add/observable/of';

// Observable operators
import * as fromCommonStore from '../../../store';
import * as commonActions from '../../../store/actions/common.actions';
import * as fromRootStore from '../../../reducers';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

import { CommonService, ServiceWalkInService, SubscribeService } from '../../../services/index';
import { ServiceWalkInModel } from '../../../model/index';
import { addCourierDetailsComponent } from './addCourierDetails.component';

@Component({
    selector: 'add-import-export-tab',
    templateUrl: './addImportExport.component.html'
})
export class AddImportExportComponent implements OnInit {
    status: any;
    export: any;
    private searchTerms = new Subject<string>();

    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        this._params = val;
        this.setPageData();
    }
    // @Input() set clientSearchEmit(val: any[]) {
    //     debugger;
    // }

    statusCusCtrl: FormControl;
    serialNoCtrl: FormControl;
    potCusCtrl: FormControl;
    clientCtrl: FormControl;
    referenceCtrl: FormControl;
    minDate: any;
    branchList: any[] = [];

    locationCtrl: FormControl;
    potCusOptList: any[];
    statusList: any[];
    clientList: any[];
    prodList: any[];
    page = {
        limit: 20,
        count: 0,
        offset: 0,
        orderBy: 'bill_id',
        orderDir: 'asc'
    };
    salesBillentryDetails = [];
    columns = [];
    filteredBranch: Observable<any[]>;
    filteredItems: Observable<any[]>;
    filteredReference: Observable<any[]>;
    @Input() servicegriddata: ServiceWalkInModel[] = [];
    @Input() serviceInData: ServiceWalkInModel[] = [];
    @ViewChild('clientAutoComp') clientAutoComp;
    @ViewChild('prodAutoComp') prodAutoComp;
    // @ViewChild('singleClientDetails') singleClientDetails;
    @ViewChild('searchComponent') searchComponent;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    itemList: any[] = [];
    isLoading: boolean = false;
    isCourierDet: boolean;


    constructor(public store: Store<fromRootStore.State>,
        private modalService: BsModalService,
        public toasterService: ToasterService,
        private commonService: CommonService,
        private bsModalRef: BsModalRef,
        private serviceWalkInService: ServiceWalkInService, public subscribeService: SubscribeService
    ) {
        this.potCusCtrl = new FormControl();
        this.statusCusCtrl = new FormControl();
        this.serialNoCtrl = new FormControl();
        this.potCusOptList = ['Yes', 'No'];
        this.statusList = ['Yes', 'No'];


        this.referenceCtrl = new FormControl();
        this.filteredReference = this.referenceCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterItems(name) : this.itemList.slice());
    }

    ngOnInit(): void {
        let that = this;
        this.filteredItems = this.searchTerms
            .debounceTime(300)        // wait 300ms after each keystroke before considering the term
            .distinctUntilChanged()   // ignore if next search term is same as previous
            .switchMap(term => term   // switch to new observable each time the term changes
                // return the http search observable
                ? this.commonService.loadClientList(term, 'walkIn')
                // or the observable of empty heroes if there was no search term
                : Observable.of<any[]>([]))
            .catch(error => {
                // TODO: add real error handling
                console.log(error);
                return Observable.of<any[]>([]);
            });

        this.filteredItems.subscribe(($e) => {
            that.clientList = $e;
        });

        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                //this.store.dispatch(new commonActions.LoadAllBrandModel());
                //this.brandModelList = res;
                return;
            }
            this.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' && obj['is_hv_center'] == 'false' });
        });

        this.columns = [
            { name: 'SNo', prop: 'sno', width: 50, minWidth: 50, maxWidth: 50, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Model', prop: 'model_name', width: 280, minWidth: 280, maxWidth: 280, sortable: false, cellClass: 'cell-left' },
            { name: 'Serial No', prop: 'serial_no', width: 110, minWidth: 110, maxWidth: 110, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand', prop: 'brand_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand Model', prop: 'brand_model_name',width:140,minWidth:140, maxWidth: 140, sortable: false, cellClass: 'cell-left' },
            { name: 'Family', prop: 'family_name',width:80,minWidth:80, maxWidth: 80, sortable: false, cellClass: 'cell-left' },
            { name: 'Series', prop: 'series_name',width:80,minWidth:80, maxWidth: 80, sortable: false, cellClass: 'cell-left' },
            { name: 'Performance', prop: 'performance_name',width:130,minWidth:130, maxWidth: 130, sortable: false, cellClass: 'cell-left' },
            { name: 'Power', prop: 'power_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Battery', prop: 'battery_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            //{ name: 'Quantity', prop: 'qty', width: 80, minWidth: 80, maxWidth: 80, sortable: false, cellClass: 'cell-left' },
        ];

        if (this._params['mode'] == 'Edit') {
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());

            //this.serviceInData['service_date'] = new Date();
            this.serviceInData['courier_date'] = new Date();
        }
        if (this._params['mode'] == 'Add') {
            this.loadAutoNumber();
        }




        this.serviceInData['random_no'] = this.getRandomInt(1, 500);


    }

    displayBranch(branchID: any) {
        if (this.branchList != undefined) {
            if (branchID && this.branchList.length > 0) {
                let fitem = _.find(this.branchList, { 'branch_id': branchID });
                //this.branchList['company_name'] = fitem.branchList; //ANOTHER FIELD
                return fitem['branch_name'];
            }
        }
        return '';

    }

    openCourierDetailModal(): void {
        this.bsModalRef = this.modalService.show(addCourierDetailsComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        let row ={
            serviceinData: this.serviceInData,
            salesbillentryDetails : this.salesBillentryDetails,
            params : this._params
        }
        this.bsModalRef.content.courierDetails = Object.assign({}, row);
        // this.bsModalRef.content.courierLoadevent.subscribe(($e) => {
        //     console.log($e);
        // })
    }

    loadAutoNumber(): void {
        let that = this,
            data = {
                account_type: 'serviceTrack',
                date: moment(this.serviceInData['date']).format('YYYY-MM-DD')
            };
        this.commonService
            .getAutoNumber(data)
            .then(function (res: any) {
                if (res['success']) {
                    that.serviceInData['auto_no'] = res['auto_no'];
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops, Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }
    setPageData(): void {

        if (this._params != undefined) {
            let mode = this._params['mode'];
            if (mode == 'Edit') {
                let data = this._params;
                this.serviceInData = this._params;
                this.serviceInData['auto_no'] = this._params['bill_no'];
                this.serviceInData['service_walkin_date'] = this._params['service_walkin_date'];
                this.serviceInData['date'] = new Date(this._params['date']);
                //  this.prodList  = this._params['prodRes'];//new Date();
                this.getModelDetails(data);
            }
        }
    }

    getModelDetails(data: any): void {

        let params = {
            //bill_id: data.bill_id,
            ser_id: data.ser_id,
            //  sale_bill_id : data.sale_bill_id,
            start: this.page.count,
            limit: this.page.limit,
            // orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`
        };

        let that = this;
        this.serviceWalkInService
            .getModelDetails(params)
            .then(function (res: any) {

                that.page.count = res.totCnt;
                that.salesBillentryDetails = res.data;
                //that.prodList  = res.data2;
            });
    }
    getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    searchClient(query: string) {
        this.searchTerms.next(query);
    }

    onEnterKeyPressed(nextEl: string): void {
        if (_.isEmpty(document.getElementById(this.serviceInData['random_no'] + '_' + nextEl))) {
            nextEl = 'followup_status';
        }
        $('#' + this.serviceInData['random_no'] + '_' + nextEl).focus();
    }

    displayFn(client_id: any) {
        if (this.clientList != undefined) {
            if (client_id && this.clientList.length > 0) {
                let fitem = _.find(this.clientList, { 'client_id': client_id });
                this.serviceInData['sale_no'] = fitem.sale_no;
                this.serviceInData['sale_date'] = fitem.sale_date;
                this.serviceInData['item'] = fitem.item;
                this.serviceInData['quantity'] = fitem.quantity;
                this.serviceInData['client_no'] = fitem.client_no;
                this.serviceInData['client_name'] = fitem.client_name;
                this.serviceInData['mobile'] = fitem.mobile; //ANOTHER FIELD
                this.serviceInData['reference_name'] = fitem.reference_name;

                /*  if () {
  
                   this.serviceInData['reference_name']
  
                  }
                  else if () {
  
                  }*/
                //  this.singleClientDetails.loadClient(fitem);//TO LOAD CLIENT OBJECT
                return fitem['client_no'];
            }
        }
        return '';
    }
    //  for loading the product and qunatity on change function 
    displayProd(model_id: any) {
        if (this.prodList != undefined) {
            if (model_id && this.prodList.length > 0) {
                let fitem = _.find(this.prodList, { 'model_id': model_id });
                //TO LOAD CLIENT OBJECT
                return fitem['name'];
            }
        }
        return '';
    }
    onChangeProd(ha: any) {
        let that = this;
        let model_id = ha.model_id;
        let fitem = _.find(this.prodList, { 'model_id': model_id });
        //TO LOAD CLIENT OBJECT
        that.servicegriddata['prod_name'] = fitem['name'];
        that.servicegriddata['quantity'] = fitem['quantity'];

    }
    // end
    resetWalkInData() {
        if (this._params['mode'] == 'Add') {
            this.serviceInData = [];
            this.serviceInData['date'] = new Date();
        }
    }
    /* loadFollowUpStatus(): void {
         let that = this;
 
         that.commonService
             .getFollowUpStatusList({})
             .then(function(res: any) {
                 that.statusList = res.data;
             });
     }*/
    displayStatusFn(fol_id: any) {
        if (this.statusList != undefined) {
            if (fol_id && this.statusList.length > 0) {
                let folObj = _.find(this.statusList, { 'fol_id': fol_id });
                return folObj['name'];
            }
        }
        return '';
    }


    filterItems(name: string) {
        name = _.escapeRegExp(name);
        return this.itemList.filter(item => (new RegExp(name, 'gi').test(item.client_code) || new RegExp(name, 'gi').test(item.name)));
    }

    displayRef(item_id: number) {
        if (item_id && this.itemList.length > 0) {
            let fitem = _.find(this.itemList, { 'ref_id': item_id });
            return fitem['prod_name'];
        }
        return '';
    }


    onSaveImportExport(row: any) {
        let that = this;
        let toast = {
            type: 'warning',
            title: 'WARNING'
        };
        if (!this.serviceInData['courier_no'] && this._params['tabParams'] != 'Import') {
            toast['body'] = 'Please Enter Courier No';
            this.toasterService.pop(toast);
            return;
        }
        if (this._params['tabParams'] == 'Import' && this._params['process'] != 'Fixed') {
            swal({
                title: 'Service Place',
                text: 'Which Service do you Provide?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Local',
                cancelButtonText: 'Export'
            }).then(function () {
                that.onImportExport('Yes');

            }, function (dismiss) {
                 //that.onImportExport('No');
                that.openCourierDetailModal();
            });
        } else {
            that.onImportExport('No');
        }

        /* else   if (!this.serviceInData['return_reason']) {
                toast['body'] = 'Please Enter Reason';
                this.toasterService.pop(toast);
                return;
            }*/

        /* if (_.isEmpty(this.serviceInData['branch_id'])) {
             toast['body'] = 'Please Choose  Send To Branch';
             this.toasterService.pop(toast);
             return;
         }
 */
    }
    onImportExport(ixdata: any) {
        if (ixdata == 'No') {
            this.export = "No";
            this.status = "exported";
        } else {
            this.export = "Yes";
            this.status = "imported";
        }
        let that = this,
            mode = this._params['mode'],
            testingDet = this.salesBillentryDetails.length;


        let testingDate = moment(this.serviceInData['service_dates']).format('YYYY-MM-DD'),
            courierDate = moment(this.serviceInData['courier_date']).format('YYYY-MM-DD'),
            data = {

                from_branch_id: this.serviceInData['from_branch'],
                ser_id: this.serviceInData['ser_id'],
                auto_no: this.serviceInData['auto_no'],
                to_branch: this.serviceInData['to_branch'],
                process: this.serviceInData['process'],
                courier_no: this.serviceInData['courier_no'],
                return_reason: this.serviceInData['return_reason'],
                courier_date: courierDate,
                courier_name: this.serviceInData['courier_name'],
                date: testingDate,
                mode: this._params['mode'],
                tabParams: this._params['tabParams'],
                status: this.status,
                export: this.export
                //salesBillentryDetails: JSON.stringify(this.salesBillentryDetails)
            };

        this.isLoading = true;

        this.serviceWalkInService
            .addSaveImportExport(data)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.subscribeService.subReloadServiceGrid();
                    that.serviceInData = [];
                    that.salesBillentryDetails = [];
                    that.subscribeService.subScribeDeleteActiveTab();
                } else {
                    swal('ERROR', res.message, 'error');
                }

            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
            });
     }

}




// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/serviceWalkIn/addImportExport.component.ts